import { Toggle } from "tailwindcss-stimulus-components";

export default class extends Toggle {
  toggle(event) {
    super.toggle(event);
    event.currentTarget.ariaExpanded = this.openValue;
  }
}
